<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>Admin</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>Admin</h2>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">미승원 회원 세부정보</h3>
        <div class="tabStyle1">
          <table>
            <caption>
              회원정보
            </caption>
            <colgroup>
              <col width="200" />
              <col width="400" />
              <col width="200" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="col" height="74"><label for="ID">ID</label></th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="ID"
                      v-model="state.userInfo.login_id"
                      disabled
                      title="ID" />
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row">
                  <label for="jobKo">직장한글명</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      maxlength="19"
                      v-model="state.userInfo.n_ctorkr"
                      id="jobKo"
                      disabled
                      title="직장한글명" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="jobEn">직장영문명</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      maxlength="50"
                      v-model="state.userInfo.n_ctoren"
                      id="jobEn"
                      disabled
                      title="직장영문명" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자구분</th>
                <td colspan="3">
                  <div class="inpSlt typeReq">
                    <button
                      type="button"
                      name="ind_corp_typ_cd"
                      class="sltBtn"
                      title="사업자구분">
                      <span>법인사업자</span>
                    </button>
                    <ul>
                      <li>
                        <button
                          type="button"
                          @click="setOption('corp', 'C')"
                          value="C"
                          class="sltOpt"
                          title="선택">
                          <span>법인사업자</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      <li>
                        <button
                          type="button"
                          @click="setOption('corp', 'P')"
                          value="P"
                          class="sltOpt">
                          <span>개인사업자</span>
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          @click="setOption('corp', 'S')"
                          value="S"
                          class="sltOpt">
                          <span>서베이</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">인수형태</th>
                <td colspan="3">
                  <div class="inpSlt typeReq">
                    <button
                      type="button"
                      name="polhd_gb"
                      class="sltBtn"
                      title="인수형태구분">
                      <span>인수형태를 선택해주세요</span>
                    </button>
                    <ul>
                      <li>
                        <button
                          type="button"
                          @click="setOption('pol', '1')"
                          value="1"
                          class="sltOpt"
                          title="선택">
                          <span>당사 단독</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      <li>
                        <button
                          type="button"
                          @click="setOption('pol', '2')"
                          value="2"
                          class="sltOpt">
                          <span>당사 간사</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="bizNum">사업자번호</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      v-model="state.userInfo.biz_no"
                      disabled
                      id="bizNum"
                      title="사업자번호" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="phone">휴대폰번호</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      style="width: 32%; margin: 3px"
                      v-model="state.userInfo.tel_no1"
                      maxlength="4"
                      id="phone1"
                      title="휴대폰번호" />-
                    <input
                      type="text"
                      style="width: 32%; margin: 3px"
                      v-model="state.userInfo.tel_no2"
                      maxlength="4"
                      id="phone2"
                      title="휴대폰번호" />-
                    <input
                      type="text"
                      style="width: 32%"
                      v-model="state.userInfo.tel_no3"
                      maxlength="4"
                      id="phone3"
                      title="휴대폰번호" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="fax">FAX</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      style="width: 32%; margin: 3px"
                      v-numeric-only
                      maxlength="4"
                      v-model="state.userInfo.fax_no1"
                      id="fax1"
                      title="FAX" />-
                    <input
                      type="text"
                      style="width: 32%; margin: 3px"
                      v-numeric-only
                      maxlength="4"
                      v-model="state.userInfo.fax_no2"
                      id="fax2"
                      title="FAX" />-
                    <input
                      type="text"
                      style="width: 32%"
                      v-numeric-only
                      maxlength="4"
                      v-model="state.userInfo.fax_no3"
                      id="fax3"
                      title="FAX" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="bir">생년월일</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      v-numeric-only
                      v-model="state.userInfo.birth_ymd"
                      placeholder="-없이 입력해 주세요"
                      id="bir"
                      title="생년월일" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="division">부서</label>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      v-model="state.userInfo.dept_nm"
                      id="division"
                      title="부서" />
                  </div>
                </td>
                <th scope="row">
                  <label for="name">담당자명</label>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      v-model="state.userInfo.charg_nm"
                      id="name"
                      title="담당자명" />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="code">담당자코드</label>
                </th>
                <td colspan="3">
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      @blur="checkNum()"
                      v-model="state.userInfo.gita"
                      id="code"
                      title="담당자코드" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="inpInfo">
          상기의 법인정보는 "신정보"에서 변경 된 경우에만, 변경된 정보만 확인
          가능합니다. (필수정보는 제외함)
        </p>

        <h3 class="conTit">승인자 입력사항</h3>
        <div class="tabStyle1">
          <table>
            <caption>
              승인자 입력사항
            </caption>
            <colgroup>
              <col width="200" />
              <col width="400" />
              <col width="200" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="col" height="74">
                  <label for="adminCode">승인자코드</label>
                </th>
                <td colspan="3">
                  <div class="typeSplit1">
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        v-model="state.userInfo.gita"
                        id="adminCode"
                        title="승인자코드" />
                    </div>
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="승인자코드 선택">
                        <span>정산</span>
                      </button>
                      <ul>
                        <li>
                          <button
                            type="button"
                            @click="setOption('cal', 'N')"
                            value="N"
                            class="sltOpt"
                            title="선택">
                            <span>정산</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                        <li>
                          <button
                            type="button"
                            @click="setOption('cal', 'Y')"
                            value="Y"
                            class="sltOpt">
                            <span>신용카드</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">협정비협정 구분</th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      class="sltBtn"
                      title="협정비협정 구분 선택">
                      <span>협정</span>
                    </button>
                    <ul>
                      <li>
                        <button
                          type="button"
                          value="1"
                          class="sltOpt"
                          title="선택"
                          @click="setOption('agrmN', '1')">
                          <span>협정</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      <li>
                        <button
                          type="button"
                          value="2"
                          class="sltOpt"
                          @click="setOption('agrmN', '2')">
                          <span>비협정</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  수입 상품,<br />
                  단위상품 코드
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      name="incPayKind"
                      class="sltBtn"
                      title="수입 상품, 단위상품 코드">
                      <span>적하수입보험, 적하보험표준약관</span>
                    </button>
                    <ul>
                      <div
                        v-for="(item, index) in state.incmProdList"
                        :key="index">
                        <li>
                          <button
                            @click="setOption('incm', item.key)"
                            type="button"
                            class="sltOpt"
                            :value="item.key">
                            <span>{{ item.value }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </div>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  수출 상품,<br />
                  단위상품 코드
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button
                      type="button"
                      name="xprtPayKind"
                      class="sltBtn"
                      title="수출 상품, 단위상품 코드">
                      <span>적하수출보험, 적하보험표준약관</span>
                    </button>
                    <ul>
                      <div
                        v-for="(item, index) in state.exptProdList"
                        :key="index">
                        <li>
                          <button
                            @click="setOption('expt', item.key)"
                            type="button"
                            class="sltOpt"
                            :value="item.key">
                            <span>{{ item.value }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </div>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="btnWrap">
          <a @click="cusInq()" class="btnType sizeR colorBL"
            ><span>목록</span></a
          >
          <a @click="reco()" class="btnType sizeR colorB"><span>승인</span></a
          ><!-- 수정 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { de } from "date-fns/locale";
import { globalState } from "@/common/globalState";

const axios = inject("axios");
const state = reactive({
  logId: "",
  bizNo: "",
  txtGita: "",
  userInfo: {},
  incmProdList: [],
  exptProdList: [],
  agrm_nagrm_typ_cd: "1",
  payKind: "Y",
  polhd_gb: "",
  ind_corp_typ_cd: "P",
  incmProd: "21000|2100A",
  exptProd: "21010|2101A",
  agrmNagrm: "1",
});
const router = useRouter();
const swalAlert = inject("swalAlert");
const store = useStore();
onMounted(async () => {
  state.logId = store.state.common.cusId;
  state.userInfo.biz_no = store.state.common.corpNo;
  await load();
  axios.json("/logHisLdg.do", {
    memo: "미승원회원세부정보",
    page: window.location.hash,
  });
  if (!_.isEmpty(sessionUserInfo)) {
    let param = {};
    param.login_id = state.logId;
    axios.json("/confirUsrDeta.do", param).then(function (result) {
      state.userInfo = rmSpaceObject(result.data.info);
      state.exptProdList = result.data.exptProdList;
      state.incmProdList = result.data.incmProdList;
      setOption("corp", result.data.info.ind_corp_typ_cd);
    });
  }
});
const setOption = (type, o) => {
  switch (type) {
    case "cal":
      o == "Y" ? (state.payKind = "Y") : (state.payKind = "N");
      break;
    case "agrmN":
      o == "1" ? (state.agrmNagrm = "1") : (state.agrmNagrm = "2");
      break;
    case "pol":
      o == "1" ? (state.polhd_gb = "1") : (state.polhd_gb = "2");
      break;
    case "corp":
      if (o == "C") {
        state.ind_corp_typ_cd = "C";
      } else if (o == "S") {
        state.ind_corp_typ_cd = "S";
      } else {
        state.ind_corp_typ_cd = "P";
      }
      break;
    case "incm":
      state.incmProd = o;
      break;
    case "expt":
      state.exptProd = o;
      break;
  }
};

const reco = () => {
  let param = {};
  param.corp_no = state.userInfo.corp_no;
  param.agrmNagrm = state.agrmNagrm;
  param.login_id = state.userInfo.login_id;
  param.gita = state.userInfo.gita;
  param.incPayKind = state.incmProd;
  param.xprtPayKind = state.exptProd;
  axios.json("/confirmUser.do", param).then(function (result) {
    return swalAlert(result.data.msg).then((result) => {
      axios.json("/logHisLdg.do", { memo: "관리자 계정 승인" });
      router.push({ name: "admMgr" });
    });
  });
};

const cusInq = () => {
  router.push({ name: "admMgr" });
};

//담당자 코드 체크
const checkNum = () => {
  var Gita = state.userInfo.gita;
  var Gita2 = 0;
  if (Gita == "" || Gita == null) {
    Gita2 = 0;
  } else {
    Gita2 = state.userInfo.gita.length;
  }
  if (Gita2 > 0) {
    if (Gita2 <= 8) {
      state.userInfo.gita = "";
      return swalAlert("담당자코드를 확인하세요.");
    } else if (
      !(
        Gita.substring(0, 1) == "1" ||
        Gita.substring(0, 1) == "3" ||
        Gita.substring(0, 1) == "5"
      )
    ) {
      state.userInfo.gita = "";
      return swalAlert("담당자코드를 확인하세요.");
    }
  }
};

function rmSpaceObject(obj) {
  return _.mapValues(obj, (value) =>
    _.isString(value) ? _.trim(value) : value
  );
}
</script>

<style></style>
